<template>
  <div class="EmpleadosListado m-t-16">
    <md-table-card>
      <md-toolbar>
        <h1 class="md-title">Empleados registrados</h1>
      </md-toolbar>
      <md-table>
        <md-table-header>
          <md-table-row>
            <md-table-head># emp</md-table-head>
            <md-table-head>Nombre</md-table-head>
            <md-table-head>Puesto</md-table-head>
            <md-table-head>Estatus</md-table-head>
            <md-table-head>Acciones</md-table-head>
          </md-table-row>
        </md-table-header>
        <md-table-body>
          <md-table-row v-for="(e,index) in empleados" :key="index">
            <md-table-cell>{{e.id_emn}}</md-table-cell>
            <md-table-cell>{{e.nombre_emn+' '+e.ap_pat_emn+' '+e.ap_mat_emn}}</md-table-cell>
            <md-table-cell>{{e.nombre_pue.toUpperCase()}},
              <small>{{e.depto_pue.toUpperCase()}}</small>
            </md-table-cell>
            <md-table-cell>{{e.estatus_ene.toUpperCase()}}</md-table-cell>
            <md-table-cell>
              <div v-if="e.archivo_enc">
                <md-button class="md-icon-button">
                  <md-icon @click.native="irEditarEmpleado(e.id_emn)">edit</md-icon>
                  <md-tooltip md-direction="left">Editar empleado</md-tooltip>
                </md-button>
                <md-button class="md-icon-button" @click.native="abrirModalEditarEstatus(e)">
                  <md-icon v-if="e.estatus_ene === 'activo'">pause</md-icon>
                  <md-icon v-else>play_arrow</md-icon>
                  <md-tooltip md-direction="left" v-if="e.estatus_ene === 'activo'">Suspender empleado</md-tooltip>
                  <md-tooltip md-direction="left" v-else>Reactivar empleado</md-tooltip>
                </md-button>
                <md-button class="md-icon-button" @click.native="irDetalleEmpleado(e.empleado)">
                  <md-icon>folder</md-icon>
                  <md-tooltip md-direction="left">Expediente del empleado</md-tooltip>
                </md-button>
              </div>
              <div v-if="!e.archivo_enc && e.estatus_ene ==='activo'">
                <md-button class="md-raised md-icon-button md-warn" @click.native="abrirModalSubirContrato(e,index)">
                  <md-icon>description</md-icon>
                  <md-tooltip md-direction="left">Subir contrato firmado</md-tooltip>
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table-body>
      </md-table>
    </md-table-card>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalEditarEstatus">
      <md-dialog-title>{{empleado.nombre_emn+' '+empleado.ap_pat_emn+' '+empleado.ap_mat_emn}}</md-dialog-title>
      <md-dialog-content>
        <md-input-container>
          <label for="estatus">Estatus</label>
          <md-select name="estatus" id="estatus" v-model="empleado.estatus_ene">
            <md-option value="activo">Activo</md-option>
            <md-option value="incapacitado">Incapacitado</md-option>
            <md-option value="renuncio">Renuncio</md-option>
            <md-option value="despedido">Despedido</md-option>
          </md-select>
        </md-input-container>
        <md-input-container>
          <label>Observaciones</label>
          <md-textarea v-model="observaciones_ene"></md-textarea>
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModalEditarEstatus()">Cancelar</md-button>
        <md-button class="md-raised md-primary" @click.native="cambiarEstatusEmpleado()">Guardar cambios</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalSubirContrato">
      <md-dialog-content>
        <div class="md-subheading">GENERAR CONTRATO PARA {{empleado.nombre_emn + ' '+empleado.ap_pat_emn + ' ' + empleado.ap_mat_emn}}<br></div>
        <md-button class="md-raised md-accent" @click.native="abrirVentanaGenerarContrato(empleado.id_emn)">Generar contrato en PDF</md-button>
        <md-input-container>
          <label>Subir contrato firmado</label>
          <md-file v-model="single" accept="application/pdf" @selected="prepararContratoSubir($event)"></md-file>
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModal('modalSubirContrato')">Cerrar</md-button>
        <md-button class="md-raised md-primary" @click.native="guardarArchivoContrato()" v-if="archivo_contrato != null">Subir contrato</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="subiendoArchivo" :md-click-outside-to-close="false" :md-esc-to-close="false">
      <md-progress md-indeterminate></md-progress>
    </md-dialog>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import $ from "jquery";
import dt from "datatables.net";

export default {
  name: "EmpleadosListado",
  methods: {
    abrirModalSubirContrato(e, i) {
      this.empleado = e;
      this.index = i;
      this.$refs["modalSubirContrato"].open();
    },
    prepararContratoSubir(e) {
      this.archivo_contrato = e[0];
    },
    hayContratoAnexado() {
      if (this.archivo_contrato) {
        return true;
      } else {
        Snackbar.show({
          text: "Debe seleccionar el archivo de su investigación",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      }
    },
    guardarArchivoContrato() {
      if (this.hayContratoAnexado()) {
        //this.cerrarModal("modalSubirContrato");
        //this.abrirModal("subiendoArchivo");
        var formData = new FormData();
        formData.append("token", this.$session.get("token"));
        formData.append("empleado", sha1(md5(this.empleado.id_emn)));
        formData.append("archivo", this.archivo_contrato);
        this.$http.post("empleados/subirContrato", formData).then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              this.empleados[this.index].archivo_enc = "a";
              Snackbar.show({
                text: response.body.msg,
                pos: "top-right",
                actionText: "Cerrar",
                showAction: false,
                duration: 20000
              });
              this.cerrarModal("modalSubirContrato");
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#CC3D30",
                actionTextColor: "#FFF"
              });
            }
            //this.cerrarModal("subiendoArchivo");
          },
          response => {
            Snackbar.show({
              text:
                "No se pudo establecer conexión con el servidor para guardar el contrato. Inténtelo de nuevo.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#CC3D30",
              actionTextColor: "#FFF"
            });
            this.cerrarModal("subiendoArchivo");
          }
        );
      }
    },
    cerrarModal(a) {
      this.$refs[a].close();
    },
    abrirVentanaGenerarContrato(e) {
      window.open(
        "http://api.grupoalarcom.mx/contratos/pdf?a=e&n=" + sha1(md5(e)),
        "_blank"
      );
    },
    obtenerEmpleados() {
      this.$http
        .post("empleados", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "empleados" in response.body) {
              this.empleados = response.body.empleados;
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    cambiarEstatusEmpleado() {
      this.$http
        .post("empleados/estatus", {
          token: this.$session.get("token"),
          empleado: this.empleado.empleado,
          data: this.empleado,
          obs: this.observaciones_ene
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right"
              });
              this.$refs["modalEditarEstatus"].close();
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    abrirModalEditarEstatus(empleado) {
      this.empleado = empleado;
      this.observaciones_ene = null;
      this.estatus_old = this.empleado.estatus_ene;
      this.$refs["modalEditarEstatus"].open();
    },
    cerrarModalEditarEstatus() {
      this.empleado.estatus_ene = this.estatus_old;
      this.$refs["modalEditarEstatus"].close();
    },
    irEditarEmpleado(empleado) {
      this.$router.push({
        name: "EmpleadosEditar",
        params: { empleado: sha1(md5(empleado)) }
      });
    },
    irDetalleEmpleado(empleado) {
      this.$router.push({
        name: "EmpleadosDetalle",
        params: { empleado: empleado }
      });
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount() {
    this.obtenerEmpleados();
  },
  updated() {
    $(".md-table table").DataTable();
  },
  data() {
    return {
      empleados: [],
      archivo_contrato: null,
      single: null,
      index: null,
      empleado: {
        id_emn: null,
        nombre_emn: null,
        ap_pat_emn: null,
        ap_mat_emn: null
      },
      observaciones_ene: null,
      estatus_old: null
    };
  }
};
</script>


// WEBPACK FOOTER //
// EmpleadosListado.vue?662db180